import { render, staticRenderFns } from "./PlaylistGroupDetail.vue?vue&type=template&id=4e89bebb&scoped=true&"
import script from "./PlaylistGroupDetail.vue?vue&type=script&lang=js&"
export * from "./PlaylistGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistGroupDetail.vue?vue&type=style&index=0&id=4e89bebb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e89bebb",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCarousel,VCarouselItem,VCol,VDialog,VLayout,VRow,VSlider})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e89bebb')) {
      api.createRecord('4e89bebb', component.options)
    } else {
      api.reload('4e89bebb', component.options)
    }
    module.hot.accept("./PlaylistGroupDetail.vue?vue&type=template&id=4e89bebb&scoped=true&", function () {
      api.rerender('4e89bebb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lcd/views/Playlist/modal/PlaylistGroupDetail.vue"
export default component.exports